export class MPaypalProduct{
    constructor(
        private name:string,
        private description:string,
        private type:string,
        private category:string){

    }
}